// extracted by mini-css-extract-plugin
export default {"signup":"nwXOKqaLzdZcdCbQCyHc","nextButton":"jJvVfHc0_OWOH699Y0MT","supportLink":"pYkQY0nZ74RcQpowewx1","container":"kMJ8ow9tm93zdUPlI34U"};